import { render, staticRenderFns } from "./MdEditCN.vue?vue&type=template&id=815ba448&"
import script from "./MdEditCN.vue?vue&type=script&lang=js&"
export * from "./MdEditCN.vue?vue&type=script&lang=js&"
import style0 from "./MdEditCN.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports